// React
import React, { useState, useEffect } from "react";
// Libraries
import PropTypes from "prop-types";
import { isEmpty, map } from "lodash";

// components
import NewTable from "@Components/NewTable";

// static data

import defaultSchedulData from "./staticData.js";

// styles
import styles from "./styles.module.css";

const HoursDays = ({ scheduleData, setScheduleData, disabled, isHours }) => {
	const [startTime, setStartTime] = useState("");
	const [endTime, setEndTime] = useState("");

	useEffect(() => {
		if (isEmpty(scheduleData)) {
			setScheduleData(defaultSchedulData);
			return;
		}
		const newScheduleData = map(scheduleData, (item) => {
			if (!item.beginTime && !item.endTime && !item.beginTimeLunch && !item.endTimeLunch) {
				return {
					...item,
					isRed: true,
				};
			}
			return {
				...item,
				isRed: false,
			};
		});
		setScheduleData(newScheduleData);
	}, []);

	const handleApplyToAll = () => {
		const updatedScheduleDataDays = scheduleData.map((item) => {
			return {
				...item,
				beginTime: startTime,
				endTime,
			};
		});
		setScheduleData(updatedScheduleDataDays);
	};

	const handleWordsDays = () => {
		const updatedScheduleDataDays = scheduleData.map((item) => {
			if (!(item.days === "Sábado" || item.days === "Domingo")) {
				return {
					...item,
					beginTime: startTime,
					endTime,
				};
			}
			return item;
		});
		setScheduleData(updatedScheduleDataDays);
	};

	const onStartTimeChange = (event) => {
		setStartTime(event.target.value);
	};

	const onEndTimeChange = (event) => {
		setEndTime(event.target.value);
	};

	const onItemTimeChange = (value, data, onKeyEndDate) => {
		const items = map(scheduleData, (item) => {
			if (item.id === data.id) {
				if (onKeyEndDate === "endTime") {
					return { ...item, endTime: value };
				}
				return { ...item, beginTime: value };
			}
			return item;
		});
		setScheduleData(items);
	};

	const rowStyle = (item) => {
		if (!item.beginTime && !item.endTime && !item.beginTimeLunch && !item.endTimeLunch) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return {};
	};

	return (
		<div className={styles.tableContainer}>
			{isHours && (
				<div className={styles.inputContainer}>
					<label htmlFor="startTime">Inicio:</label>
					<input type="time" id="startTime" value={startTime} onChange={onStartTimeChange} disabled={disabled} />
					<label htmlFor="endTime">Fin:</label>
					<input type="time" id="endTime" value={endTime} onChange={onEndTimeChange} disabled={disabled} />
					<div className={styles.buttonsContainer}>
						<button type="button" onClick={handleApplyToAll} disabled={disabled || (!startTime && !endTime)} className={styles.buttons}>
							Todos
						</button>
						<button type="button" onClick={handleWordsDays} disabled={disabled || (!startTime && !endTime)} className={styles.buttons}>
							Laborales
						</button>
					</div>
				</div>
			)}
			<NewTable
				data={scheduleData}
				columns={[
					{
						label: "Días",
						key: "days",
						format: "string",
						width: 4,
					},
					{
						label: "Inicio",
						key: "beginTime",
						onKeyEndDate: "beginTime",
						format: "inputHour",
						width: 6,
						disabled,
					},
					{
						label: "Fin",
						key: "endTime",
						onKeyEndDate: "endTime",
						format: "inputHour",
						width: 6,
						disabled,
					},
				]}
				defaultOrder={{ key: "id", dir: "asc" }}
				pageRows={100}
				haveFooter={false}
				searchPosition="left"
				handlerTable={() => {
					return null;
				}}
				mobileCardView
				cardLine1={[{ key: "days", label: "" }]}
				cardLine2={[
					{ key: "beginTime", label: "Inicio", format: "inputHour", onKeyEndDate: "beginTime", disabled },
					{ key: "endTime", label: "Fin", format: "inputHour", onKeyEndDate: "endTime", disabled },
				]}
				onInputChange={onItemTimeChange}
				rowStyle={rowStyle}
			/>
		</div>
	);
};

HoursDays.propTypes = {
	scheduleData: PropTypes.array,
	setScheduleData: PropTypes.func,
	disabled: PropTypes.bool,
	isHours: PropTypes.bool,
};

HoursDays.propTypes = {
	scheduleData: PropTypes.array,
	setScheduleData: PropTypes.func,
	disabled: PropTypes.bool,
	isHours: PropTypes.bool,
};

export default HoursDays;
